// Phone formatting is now handled after city country codes are fetched

export default function applyTemplate({invoiceData, templateData}) {
    const fieldsToApply = [
        "user_type", "payment_on_receipt", "places", "vat",
        "cityTo", "cityFrom", "cityToLabel", "cityFromLabel",
        "additional_sum", "addressFrom", "addressTo",
        "reciver", "sender", "additions", "pvzTo", "tariff"
    ]
    const fieldsMappings = {
        "payment_on_receipt": "pay_on_recieve",
        "user_type": "who_pay",
        "cityTo": "city_to",
        "cityFrom": "city_from",
        "cityToLabel": "city_to_label",
        "cityFromLabel": "city_from_label",
        "additional_sum": "addition_sum",
        "addressFrom": "from_address",
        "addressTo": "to_address",
        "additions": "services",
        "pvzTo": "to_pvz_address",
        "tariff": "tariff_code",
    }

    // Deep copy delivery to avoid mutating the original invoiceData
    const existingDelivery = invoiceData.delivery;
    let dataToMerge = {
        delivery: existingDelivery ? {
            sender: {
                fio: existingDelivery.sender?.fio || '',
                contract_face: existingDelivery.sender?.contract_face || '',
                phones: (existingDelivery.sender?.phones || []).map(p => ({...p}))
            },
            recipient: {
                fio: existingDelivery.recipient?.fio || '',
                contract_face: existingDelivery.recipient?.contract_face || '',
                phones: (existingDelivery.recipient?.phones || []).map(p => ({...p}))
            }
        } : {
            sender: { fio: '', contract_face: '', phones: [{ number: '', additional: '' }] },
            recipient: { fio: '', contract_face: '', phones: [{ number: '', additional: '' }] }
        }
    }

    if (!templateData || Object.keys(templateData).length === 0) return;

    fieldsToApply.forEach(field => {
        let t_data;

        if (field === "reciver") {
            try {
                t_data = JSON.parse(templateData[field])
                
                // Country code will be determined after city info is fetched
                
                dataToMerge.delivery.recipient = {
                    fio: t_data.FIO || dataToMerge.delivery.recipient?.fio || '',
                    contract_face: t_data.contact_face || dataToMerge.delivery.recipient?.contract_face || '',
                    phones: t_data.phones?.map((phone) => {
                        return {
                            number: phone.number, // Don't format yet, will be formatted after country codes are fetched
                            additional: phone.additional || ''
                        }
                    }) || dataToMerge.delivery.recipient?.phones || [{ number: '', additional: '' }]
                };
            } catch (e) {

            }
            return
        }

        if (field === "sender") {
            try {
                t_data = JSON.parse(templateData[field])
                
                // Country code will be determined after city info is fetched
                
                dataToMerge.delivery.sender = {
                    fio: t_data.FIO || dataToMerge.delivery.sender?.fio || '',
                    contract_face: t_data.contact_face || dataToMerge.delivery.sender?.contract_face || '',
                    phones: t_data.phones?.map((phone) => {
                        return {
                            number: phone.number, // Don't format yet, will be formatted after country codes are fetched
                            additional: phone.additional || ''
                        }
                    }) || dataToMerge.delivery.sender?.phones || [{ number: '', additional: '' }]
                };
            } catch (e) {

            }
            return
        }

        if (field === "additions") {
            // Check if services field exists in template data
            if (templateData.services !== undefined && templateData.services !== null) {
                try {
                    // If it's a string, parse it as JSON
                    if (typeof templateData.services === 'string') {
                        // Handle empty string case
                        if (templateData.services.trim() === '') {
                            return; // Skip if empty string
                        }
                        t_data = JSON.parse(templateData.services)
                    } else {
                        // If it's already an object, use it directly
                        t_data = templateData.services
                    }
                } catch (e) {
                    // If parsing fails, skip this field (don't overwrite with invalid data)
                    console.warn('Failed to parse services from template:', e);
                    return;
                }
            } else {
                // If services doesn't exist, skip this field (don't overwrite existing additions)
                return;
            }

            console.log('Loaded services from template:', t_data)

            // Set the parsed services data (even if it's an empty object, as that's explicit)
            dataToMerge[field] = t_data;
            // Mark that additions came from template - this flag persists to prevent clearing
            dataToMerge._additionsFromTemplate = true;

            return;
        }

        try {
            t_data = JSON.parse(templateData[field])
        } catch (e) {
            t_data = templateData[field]

            if (fieldsMappings[field]) {
                console.log(`Applying template field: ${field} -> ${fieldsMappings[field]} = ${templateData[fieldsMappings[field]]}`)
                t_data = templateData[fieldsMappings[field]]
            }
        }

        if (t_data === undefined || t_data === null) {
            return
        }

        if (field === "places") {
            t_data = t_data.map((place, index) => ({
                ...place,
                goods: place.goods.map((good, good_index) => ({
                    ...good,
                    insurance: good.price,
                    price: good.price_alter_vat,
                    vat: good.vat_rate,
                    count: good.quantity
                }))
            }))
        }

        dataToMerge[field] = t_data;
    })

    console.log(dataToMerge)
    return dataToMerge
}